/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ActivityResponseDTO } from '../models';
// @ts-ignore
import type { ActivityStatsDTO } from '../models';
// @ts-ignore
import type { ActivityType } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageActivityResponseDTO } from '../models';
/**
 * ActivitiesApi - axios parameter creator
 * @export
 */
export const ActivitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Toggle acknowledgment status of an activity
         * @summary Acknowledge Activity
         * @param {string} activityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch: async (activityId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch', 'activityId', activityId)
            const localVarPath = `/api/v1/activities/{activity_id}/acknowledge`
                .replace(`{${"activity_id"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle acknowledgment status of an activity
         * @summary Acknowledge Activity
         * @param {string} activityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch_1: async (activityId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch_1', 'activityId', activityId)
            const localVarPath = `/api/v1/activities/{activity_id}/acknowledge`
                .replace(`{${"activity_id"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all activities for a specific call log
         * @summary Get Activities By Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet', 'callLogId', callLogId)
            const localVarPath = `/api/v1/activities/by-call-log/{call_log_id}`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all activities for a specific call log
         * @summary Get Activities By Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet_2: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet_2', 'callLogId', callLogId)
            const localVarPath = `/api/v1/activities/by-call-log/{call_log_id}`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all activities for a specific entity
         * @summary Get Activities By Entity
         * @param {string} entityType 
         * @param {string} entityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet: async (entityType: string, entityId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet', 'entityId', entityId)
            const localVarPath = `/api/v1/activities/by-entity/{entity_type}/{entity_id}`
                .replace(`{${"entity_type"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all activities for a specific entity
         * @summary Get Activities By Entity
         * @param {string} entityType 
         * @param {string} entityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet_3: async (entityType: string, entityId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet_3', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet_3', 'entityId', entityId)
            const localVarPath = `/api/v1/activities/by-entity/{entity_type}/{entity_id}`
                .replace(`{${"entity_type"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific activity by ID
         * @summary Get Activity
         * @param {string} activityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityApiV1ActivitiesActivityIdGet: async (activityId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('getActivityApiV1ActivitiesActivityIdGet', 'activityId', activityId)
            const localVarPath = `/api/v1/activities/{activity_id}`
                .replace(`{${"activity_id"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific activity by ID
         * @summary Get Activity
         * @param {string} activityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityApiV1ActivitiesActivityIdGet_4: async (activityId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('getActivityApiV1ActivitiesActivityIdGet_4', 'activityId', activityId)
            const localVarPath = `/api/v1/activities/{activity_id}`
                .replace(`{${"activity_id"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get activity statistics
         * @summary Get Activity Stats
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityStatsApiV1ActivitiesStatsGet: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/activities/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get activity statistics
         * @summary Get Activity Stats
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityStatsApiV1ActivitiesStatsGet_5: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/activities/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all activities with optional filtering
         * @summary List Activities
         * @param {Array<ActivityType> | null} [types] Filter by activity types
         * @param {boolean | null} [acknowledged] Filter by acknowledgment status (true/false/null for all)
         * @param {string | null} [startDate] Start of time range (inclusive)
         * @param {string | null} [endDate] End of time range (inclusive)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActivitiesApiV1ActivitiesGet: async (types?: Array<ActivityType> | null, acknowledged?: boolean | null, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (types) {
                localVarQueryParameter['types'] = types;
            }

            if (acknowledged !== undefined) {
                localVarQueryParameter['acknowledged'] = acknowledged;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all activities with optional filtering
         * @summary List Activities
         * @param {Array<ActivityType> | null} [types] Filter by activity types
         * @param {boolean | null} [acknowledged] Filter by acknowledgment status (true/false/null for all)
         * @param {string | null} [startDate] Start of time range (inclusive)
         * @param {string | null} [endDate] End of time range (inclusive)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActivitiesApiV1ActivitiesGet_6: async (types?: Array<ActivityType> | null, acknowledged?: boolean | null, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (types) {
                localVarQueryParameter['types'] = types;
            }

            if (acknowledged !== undefined) {
                localVarQueryParameter['acknowledged'] = acknowledged;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivitiesApi - functional programming interface
 * @export
 */
export const ActivitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * Toggle acknowledgment status of an activity
         * @summary Acknowledge Activity
         * @param {string} activityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch(activityId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch(activityId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle acknowledgment status of an activity
         * @summary Acknowledge Activity
         * @param {string} activityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch_1(activityId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch_1(activityId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all activities for a specific call log
         * @summary Get Activities By Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all activities for a specific call log
         * @summary Get Activities By Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet_2(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet_2(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all activities for a specific entity
         * @summary Get Activities By Entity
         * @param {string} entityType 
         * @param {string} entityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet(entityType: string, entityId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet(entityType, entityId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all activities for a specific entity
         * @summary Get Activities By Entity
         * @param {string} entityType 
         * @param {string} entityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet_3(entityType: string, entityId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet_3(entityType, entityId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific activity by ID
         * @summary Get Activity
         * @param {string} activityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityApiV1ActivitiesActivityIdGet(activityId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityApiV1ActivitiesActivityIdGet(activityId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getActivityApiV1ActivitiesActivityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific activity by ID
         * @summary Get Activity
         * @param {string} activityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityApiV1ActivitiesActivityIdGet_4(activityId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityApiV1ActivitiesActivityIdGet_4(activityId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getActivityApiV1ActivitiesActivityIdGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get activity statistics
         * @summary Get Activity Stats
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityStatsApiV1ActivitiesStatsGet(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityStatsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityStatsApiV1ActivitiesStatsGet(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getActivityStatsApiV1ActivitiesStatsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get activity statistics
         * @summary Get Activity Stats
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityStatsApiV1ActivitiesStatsGet_5(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityStatsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityStatsApiV1ActivitiesStatsGet_5(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getActivityStatsApiV1ActivitiesStatsGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all activities with optional filtering
         * @summary List Activities
         * @param {Array<ActivityType> | null} [types] Filter by activity types
         * @param {boolean | null} [acknowledged] Filter by acknowledgment status (true/false/null for all)
         * @param {string | null} [startDate] Start of time range (inclusive)
         * @param {string | null} [endDate] End of time range (inclusive)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActivitiesApiV1ActivitiesGet(types?: Array<ActivityType> | null, acknowledged?: boolean | null, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageActivityResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActivitiesApiV1ActivitiesGet(types, acknowledged, startDate, endDate, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.listActivitiesApiV1ActivitiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all activities with optional filtering
         * @summary List Activities
         * @param {Array<ActivityType> | null} [types] Filter by activity types
         * @param {boolean | null} [acknowledged] Filter by acknowledgment status (true/false/null for all)
         * @param {string | null} [startDate] Start of time range (inclusive)
         * @param {string | null} [endDate] End of time range (inclusive)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActivitiesApiV1ActivitiesGet_6(types?: Array<ActivityType> | null, acknowledged?: boolean | null, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageActivityResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActivitiesApiV1ActivitiesGet_6(types, acknowledged, startDate, endDate, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.listActivitiesApiV1ActivitiesGet_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActivitiesApi - factory interface
 * @export
 */
export const ActivitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivitiesApiFp(configuration)
    return {
        /**
         * Toggle acknowledgment status of an activity
         * @summary Acknowledge Activity
         * @param {string} activityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch(activityId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ActivityResponseDTO> {
            return localVarFp.acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch(activityId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle acknowledgment status of an activity
         * @summary Acknowledge Activity
         * @param {string} activityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch_1(activityId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ActivityResponseDTO> {
            return localVarFp.acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch_1(activityId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all activities for a specific call log
         * @summary Get Activities By Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActivityResponseDTO>> {
            return localVarFp.getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all activities for a specific call log
         * @summary Get Activities By Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet_2(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActivityResponseDTO>> {
            return localVarFp.getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet_2(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all activities for a specific entity
         * @summary Get Activities By Entity
         * @param {string} entityType 
         * @param {string} entityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet(entityType: string, entityId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActivityResponseDTO>> {
            return localVarFp.getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet(entityType, entityId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all activities for a specific entity
         * @summary Get Activities By Entity
         * @param {string} entityType 
         * @param {string} entityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet_3(entityType: string, entityId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActivityResponseDTO>> {
            return localVarFp.getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet_3(entityType, entityId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific activity by ID
         * @summary Get Activity
         * @param {string} activityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityApiV1ActivitiesActivityIdGet(activityId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ActivityResponseDTO> {
            return localVarFp.getActivityApiV1ActivitiesActivityIdGet(activityId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific activity by ID
         * @summary Get Activity
         * @param {string} activityId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityApiV1ActivitiesActivityIdGet_4(activityId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ActivityResponseDTO> {
            return localVarFp.getActivityApiV1ActivitiesActivityIdGet_4(activityId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get activity statistics
         * @summary Get Activity Stats
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityStatsApiV1ActivitiesStatsGet(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ActivityStatsDTO> {
            return localVarFp.getActivityStatsApiV1ActivitiesStatsGet(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get activity statistics
         * @summary Get Activity Stats
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityStatsApiV1ActivitiesStatsGet_5(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ActivityStatsDTO> {
            return localVarFp.getActivityStatsApiV1ActivitiesStatsGet_5(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all activities with optional filtering
         * @summary List Activities
         * @param {Array<ActivityType> | null} [types] Filter by activity types
         * @param {boolean | null} [acknowledged] Filter by acknowledgment status (true/false/null for all)
         * @param {string | null} [startDate] Start of time range (inclusive)
         * @param {string | null} [endDate] End of time range (inclusive)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActivitiesApiV1ActivitiesGet(types?: Array<ActivityType> | null, acknowledged?: boolean | null, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageActivityResponseDTO> {
            return localVarFp.listActivitiesApiV1ActivitiesGet(types, acknowledged, startDate, endDate, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all activities with optional filtering
         * @summary List Activities
         * @param {Array<ActivityType> | null} [types] Filter by activity types
         * @param {boolean | null} [acknowledged] Filter by acknowledgment status (true/false/null for all)
         * @param {string | null} [startDate] Start of time range (inclusive)
         * @param {string | null} [endDate] End of time range (inclusive)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActivitiesApiV1ActivitiesGet_6(types?: Array<ActivityType> | null, acknowledged?: boolean | null, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageActivityResponseDTO> {
            return localVarFp.listActivitiesApiV1ActivitiesGet_6(types, acknowledged, startDate, endDate, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivitiesApi - object-oriented interface
 * @export
 * @class ActivitiesApi
 * @extends {BaseAPI}
 */
export class ActivitiesApi extends BaseAPI {
    /**
     * Toggle acknowledgment status of an activity
     * @summary Acknowledge Activity
     * @param {string} activityId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch(activityId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch(activityId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle acknowledgment status of an activity
     * @summary Acknowledge Activity
     * @param {string} activityId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch_1(activityId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).acknowledgeActivityApiV1ActivitiesActivityIdAcknowledgePatch_1(activityId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all activities for a specific call log
     * @summary Get Activities By Call Log
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all activities for a specific call log
     * @summary Get Activities By Call Log
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet_2(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getActivitiesByCallLogApiV1ActivitiesByCallLogCallLogIdGet_2(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all activities for a specific entity
     * @summary Get Activities By Entity
     * @param {string} entityType 
     * @param {string} entityId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet(entityType: string, entityId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet(entityType, entityId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all activities for a specific entity
     * @summary Get Activities By Entity
     * @param {string} entityType 
     * @param {string} entityId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet_3(entityType: string, entityId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getActivitiesByEntityApiV1ActivitiesByEntityEntityTypeEntityIdGet_3(entityType, entityId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific activity by ID
     * @summary Get Activity
     * @param {string} activityId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getActivityApiV1ActivitiesActivityIdGet(activityId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getActivityApiV1ActivitiesActivityIdGet(activityId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific activity by ID
     * @summary Get Activity
     * @param {string} activityId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getActivityApiV1ActivitiesActivityIdGet_4(activityId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getActivityApiV1ActivitiesActivityIdGet_4(activityId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get activity statistics
     * @summary Get Activity Stats
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getActivityStatsApiV1ActivitiesStatsGet(authorization?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getActivityStatsApiV1ActivitiesStatsGet(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get activity statistics
     * @summary Get Activity Stats
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getActivityStatsApiV1ActivitiesStatsGet_5(authorization?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getActivityStatsApiV1ActivitiesStatsGet_5(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all activities with optional filtering
     * @summary List Activities
     * @param {Array<ActivityType> | null} [types] Filter by activity types
     * @param {boolean | null} [acknowledged] Filter by acknowledgment status (true/false/null for all)
     * @param {string | null} [startDate] Start of time range (inclusive)
     * @param {string | null} [endDate] End of time range (inclusive)
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public listActivitiesApiV1ActivitiesGet(types?: Array<ActivityType> | null, acknowledged?: boolean | null, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).listActivitiesApiV1ActivitiesGet(types, acknowledged, startDate, endDate, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all activities with optional filtering
     * @summary List Activities
     * @param {Array<ActivityType> | null} [types] Filter by activity types
     * @param {boolean | null} [acknowledged] Filter by acknowledgment status (true/false/null for all)
     * @param {string | null} [startDate] Start of time range (inclusive)
     * @param {string | null} [endDate] End of time range (inclusive)
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public listActivitiesApiV1ActivitiesGet_6(types?: Array<ActivityType> | null, acknowledged?: boolean | null, startDate?: string | null, endDate?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).listActivitiesApiV1ActivitiesGet_6(types, acknowledged, startDate, endDate, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

